<template>
    <div>
        <!-- <b-col v-if="isServiceOrTask(itemTypeId)" class="d-flex py-3">
            <page-actions :dropdown-actions="otherActions" control-size="sm" />
        </b-col> -->
        <slot></slot>
        <div class="responsive-table w-100 overflow-auto">
            <table
                ref="selectableTable"
                class="table b-table b-table-selectable b-table-select-multi"
            >
                <thead>
                    <tr>
                        <th v-for="field in fields" :key="field.key">
                            <span v-if="!!field.label">
                                <span v-html="field.label"></span>
                            </span>
                            <span v-else>
                                <!-- <div v-if="fields.includes('service_check')">
                                    <input
                                        type="checkbox"
                                        v-model="serviceSelectAll"
                                        :disabled="
                                            isCompleted || (viewMode && !isNew)
                                        "
                                        :checked="updateSelectAll"
                                        @change="toggleServiceSelectAll()"
                                    />
                                </div>
                                <div v-if="fields.includes('task_check')">
                                    <input
                                        type="checkbox"
                                        v-model="taskSelectAll"
                                        :disabled="
                                            isCompleted || (viewMode && !isNew)
                                        "
                                        :checked="updateSelectAll"
                                        @change="toggleAllTaskRow()"
                                    />
                                </div> -->
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody :class="'table' + tableIndex" class="table">
                    <!-- @end="onDragEnd" -->
                    <tr
                        v-for="item in arrangedItems"
                        :key="item.hash"
                        class="draggable-item"
                    >
                        <td>
                            <div class="d-flex justify-content-start">
                                <b-button
                                  :id="'view-order-rental-item-'+item.hash"
                                    class="me-1"
                                    variant="pink-button"
                                    @click="$emit('view-item', item.hash)"
                                >
                                    <img
                                        src="@/assets/images/icon/view.svg"
                                        :disable="viewMode && !isNew"
                                        alt="View"
                                    />
                                </b-button>
                                <b-button
                                :id="'delete-order-rental-item-'+item.hash"
                                    :disabled="
                                        (viewMode && !isNew) ||
                                        item.is_template_item
                                    "
                                    @click="deleteItem(item.hash)"
                                    v-if="
                                        hasPermissionDelete && !order.completed
                                    "
                                    variant="pink-button"
                                    class="me-1"
                                >
                                    <img
                                        src="@/assets/images/icon/delete.svg"
                                        alt="Delete"
                                    />
                                </b-button>
                                <b-button
                                    :id="'return-order-item-'+item.hash"
                                    v-if="(item.id && item.id > 0) && order.completed"
                                    class="text-white"
                                    variant="pink-button"
                                    @click="$emit('return-item', item.hash)" :title="$translate('return_asset')"
                                    v-b-tooltip.hover
                                >
                                    <i class="fa fa-handshake-alt-slash" :disable="viewMode && !isNew"></i>
                                    
                                </b-button>
                            </div>
                        </td>
                        <td>{{ item.asset?.serial_no }}</td>
                        <td>{{ item.asset?.name }}</td>
                        <td>
                            <span
                                v-if="item?.asset?.description"
                                style="font-weight: bold"
                            >
                                {{ item?.asset?.description }}
                            </span>
                        </td>
                        <td>${{ item.estimated_rental_rate |  currency }}</td>
                        <td>{{ item.estimated_total_rental_tax }}</td>
                        <td>{{ item.tax_rate }}</td>
                        <td>{{ formatDateTime(item.start_rental_at) }}</td>
                        <td>{{ item.estimated_rental_days }}</td>
                        <td>{{  (item.estimated_rental_rate * (item.estimated_rental_days - item.estimated_days_holiday )  ) | currency }}</td>
                        <td>{{ item.actual_returned_at ? formatDateTime(item.actual_returned_at): '' }}</td>
                        <td>{{ (item.id > 0 ? item.actual_rental_rate : 0) |  currency }}</td>
                        <td>{{ (item.id > 0 ? item.actual_total_rental_amount : 0) |  currency }}</td>
                        <td>{{ (item.id > 0 ? item.actual_total_rental_tax : 0) |  currency }}</td>
                        <td>{{ item.returned_by_user ? `${item.returned_by_user.first_name} ${item.returned_by_user.last_name}` : ''  }}</td>
                        <td>{{ item?.asset?.location_section?.location? displayLocation(item?.asset) : "" }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
// import PageActions from '@/components/PageActions.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
// import draggable from 'vuedraggable'

export default {
    components: {
        // PageActions,
        // draggable,
    },
    name: 'orders-displayOrderRentalAssetItems',
    data: () => ({
        criteria: null,
        draggableOptions: {
            animation: 300,
        },
        type: null,
        selectedItems: [],
        isAssignment: true,
        serviceSelectAll: false,
        taskSelectAll: false,
        text: 'Sample Text',
    }),
    props: [
        'asset_items',
        'viewMode',
        'customerAssets',
        //'itemTypeId',
        'tableIndex',
        'isNew',
    ],

    mixins: [popupMixins, permissionsMixins],
    filters: {
        displayTypeName(id, itemTypes) {
            return (itemTypes.find(x => x.id == id) || {}).name
        },
        formatLocation(s) {
            s = s || {}
            s.location = s.location || {}
            return `${s.name}, ${s.location.address1}, ${s.location.city}`
        },
        currency: num => {
            if(!num) return;
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
    },
    computed: {
        // otherActions() {
        //     const actions = []
        //     if (this.isServiceOrTask(this.itemTypeId)) {
        //         const updateDisabled = !(
        //             this.selectedItems.length > 0 &&
        //             this.hasPermissionUpdate &&
        //             !this.viewMode
        //         )
        //         actions.push({
        //             action: () => this.bulkCheckoff(),
        //             text: this.$translate('bulk_checkoff'),
        //             disabled: updateDisabled,
        //             dropdownButtonClass: 'w-auto h-auto',
        //         })
        //     }
        //     return actions
        // },
        arrangedItems() {
            console.log('items are',this.asset_items);
            return this.asset_items
                .slice()
                .sort((a, b) => a.display_order - b.display_order)
        },
        isCompleted() {
            console.log('orders', this.$store.state.orders.item.completed)
            return !!this.$store.state.orders.item.completed
        },
        order() {
            const order = this.$store.state.orders.item

            return { ...(order || {}) }
        },
        serviceItems() {
            const { isService } = this /////chnaged from items to items
            return this.asset_items.filter(x =>
                isService(x.order_item_type_id)
            )
        },
        taskItems() {
            const { isTask } = this /////chnaged from items to items
            return this.asset_items.filter(x => isTask(x.order_item_type_id))
        },
        itemTypes() {
            return this.$store.state.itemType.items
        },

        options() {
            return [
                { text: 'Assignment', value: true },
                { text: 'Check-Off', value: false },
            ]
        },
        fields() {

            const _fields = [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                    stickyColumn: true,
                },
                { key: 'serial_no', label: this.$translate('serial_no') },
                { key: 'name', label: this.$translate('name') },
                { key: 'details', label: this.$translate('description') },
                { key: 'estimated_price', label: this.$translate('estimated_rental_rate') },
                { key: 'estimated_total_rental_tax', label: this.$translate('estimated_total_rental_tax') },
                { key: 'tax_rate', label: this.$translate('tax_rate') },
                { key: 'start_rental_at', label: this.$translate('start_rental_at') },
                { key: 'estimated_rental_days', label: this.$translate('estimated_rental_days') },
                { key: 'estimated_total_rental_rate', label: this.$translate('estimated_total_rental_rate') },
                { key: 'actual_returned_at', label: this.$translate('actual_returned_at') },
                { key: 'actual_rental_rate', label: this.$translate('actual_rental_rate') },
                { key: 'actual_total_rental_amount', label: this.$translate('actual_total_rental_amount') },
                { key: 'actual_total_rental_tax', label: this.$translate('actual_total_rental_tax') },
                { key: 'asset_returned_by', label: this.$translate('asset_returned_by') },
                { key: 'location', label: this.$translate('location') },
            ]
            return _fields
        },
    },
    watch: {
        selectedItems: {
            handler() {
                this.updateSelectAll()
                this.updateTastSelectAll()
            },
            deep: true,
        },
        isAssignment: function (val) {
            this.$emit('toggleAssignment', !val)
        },
        order: {
            handler: function (_order) {
                console.log('computed---order', _order)
                this.$emit('order-status', _order.completed)
                console.log('computed---order--status', _order.completed)
            },
            deep: true,
        },
    },
    mounted() {
        console.log('this.filterdItems', this.asset_items)
        this.$nextTick().then(() => {
            this.$emit('toggleAssignment', !this.isAssignment)
        })
    },
    methods: {
        formatDateTime(dateTime) {
        // Create a new Date object from the input dateTime
        const date = new Date(dateTime);

        // Format the date as d/my h:i
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Construct the formatted date and time string
        const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;

        return formattedDateTime;
       },
        async onDragEnd(event) {
            this.asset_items.splice(
                event.newIndex,
                0,
                this.asset_items.splice(event.oldIndex, 1)[0]
            )
            this.asset_items.forEach(function (items, index) {
                items.order = index
            })
            await this.$store.dispatch(
                'orderRentalAssetStore/arrange',
                this.asset_items
            )
        },
        // toggleServiceSelectAll() {
        //     if (this.serviceSelectAll && this.isService(this.itemTypeId)) {
        //         this.selectedItems = this.asset_items
        //             .filter(item => item.id)
        //             .map(item => item)
        //     } else {
        //         this.selectedItems = []
        //     }
        // },
        updateSelectAll() {
            console.log('this.serviceItems', this.serviceItems)
            const allChecked =
                this.serviceItems.length === this.selectedItems.length
            if (allChecked && !this.serviceSelectAll) {
                this.serviceSelectAll = true
            } else if (!allChecked && this.serviceSelectAll) {
                this.serviceSelectAll = false
            }
        },
        isSelected(index) {
            return this.selectedItems.some(item => item.id == index)
        },
        toggleServiceRow(items) {
            if (this.isSelected(items.id)) {
                this.selectedItems = this.selectedItems.filter(
                    selectedIndex => selectedIndex.id !== items.id
                )
            } else {
                this.onRowSelected(items)
            }
            this.updateSelectAll()
        },
        onRowSelected(items) {
            console.log('item', items)
            this.selectedItems.push(items)
        },
        clearSelected() {
            this.selectedItems = []
        },
        // updateTastSelectAll() {
        //     console.log('this.serviceItems', this.serviceItems)
        //     const allChecked =
        //         this.taskItems.length === this.selectedItems.length
        //     if (
        //         allChecked &&
        //         !this.taskSelectAll &&
        //         this.isTask(this.itemTypeId)
        //     ) {
        //         this.taskSelectAll = true
        //     } else if (
        //         !allChecked &&
        //         this.taskSelectAll &&
        //         this.isTask(this.itemTypeId)
        //     ) {
        //         this.taskSelectAll = false
        //     }
        // },
        toggleTaskRow(items) {
            if (this.isSelected(items.id)) {
                this.selectedItems = this.selectedItems.filter(
                    selectedIndex => selectedIndex.id !== items.id
                )
            } else {
                this.onRowSelected(items)
            }
            this.updateSelectAll()
        },
        // toggleAllTaskRow() {
        //     if (this.taskSelectAll && this.isTask(this.itemTypeId)) {
        //         this.selectedItems = this.asset_items
        //             .filter(item => item.id)
        //             .map(item => item)
        //     } else {
        //         this.selectedItems = []
        //     }
        // },
        deleteItem(hash) {
            const title = this.$translate('delete_item_title')
            const message = this.$translate(`delete_note`)
            this.confirmMessage(title, message)
                .then(result => {
                    if (result) {
                        this.doToast(
                            this.$translate('success'),
                            `${this.$translate('item')} ${this.$translate(
                                'delete_alert'
                            )}`,
                            'success'
                        )
                        this.$store.dispatch('orderRentalAssetStore/delete', hash)
                    }
                })
                .catch(() => {
                    this.doToast(
                        this.$translate('error'),
                        this.$translate('unable_alert'),
                        'danger'
                    )
                })
        },
        calculateItemCost(item) {
            return (
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            )
        },

        calculateItemTax(item) {
            let itemCost =
                (parseFloat(item.price) || 0) * (parseFloat(item.quantity) || 0)
            return (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
        },

        displayAssets(ids) {
            // x.name + ' ' + x.serial_no,
            const { customerAssets } = this
            const assets = ids
                .map(id => customerAssets.find(asset => asset.id == id))
                .filter(x => !!x)

            const _html = assets.reduce((_str, asset, idx, _list) => {
                const { name, serial_no } = asset
                if (idx === 0) {
                    _str = `<b>Asset${_list.length > 0 ? 's' : ''}:</b> `
                }
                _str += `<br/>${idx + 1}&#58; ${name}${
                    serial_no ? '-' + serial_no : ''
                }`
                return _str
            }, '')
            return _html
        },
        fieldData(item, fieldKey) {
            console.log(
                'fieldKey',
                fieldKey,
                this.fields.find(field => field.key === fieldKey)
            )
            const field = this.fields.find(field => field.key === fieldKey)
            if (field) {
                return item[field.key]
            }
            return '' // Default value if field is not found
        },

        // isProduct(itemTypeId) {
        //     const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
        //     return !!(type.is_order_item && !type.is_task && !type.is_discount)
        // },
        // isService(itemTypeId) {
        //     const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
        //     return !!(type.is_order_item && type.is_task && !type.is_discount)
        // },
        // isTask(itemTypeId) {
        //     const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
        //     return !!(!type.is_order_item && type.is_task && !type.is_discount)
        // },
        // isServiceOrTask(itemTypeId) {
        //     const type = this.itemTypes.find(x => itemTypeId === x.id) || {}
        //     return !!(type.is_task && !type.is_discount)
        // },

        async bulkCheckoff() {
            const title = this.$translate('bulk_checkoff')
            const message = this.$translate(`bulk_checkoff_note`)
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    const bulkcheckoff = this.selectedItems.map(x => x.id)
                    const id = this.order.id
                    // console.log('orders--tests', bulkcheckofftask)
                    this.$store
                        .dispatch('orders/bulkCheckoff', { bulkcheckoff, id })
                        .then(() => {
                            this.doToast(
                                this.$translate('success'),
                                this.$translate('bulk_checkoff_successfully'),
                                'success'
                            )
                            this.clearSelected()
                            this.$store.dispatch('orders/fetchOrderItems', id)
                        })
                        .catch(err => {
                            console.log(err.message, 'bulk_checkoff_error')
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('bulk_checkoff_error'),
                                'danger'
                            )
                        })
                }
            })
        },
        
        displayLocation(asset) {
            const location = asset?.location_section?.location;
            const section = asset?.location_section;
            return `${section?.name}, ${location?.address1}, ${location?.city}`
        },
    },
}
</script>

<style scoped>
ul {
    margin: 0;
}

ul.dashed {
    list-style-type: none;
}

ul.dashed > li {
    text-indent: -30px;
}

ul.dashed > li:before {
    content: '';
    text-indent: -30px;
}
</style>
